import { render } from "./Index.vue?vue&type=template&id=585ec218&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=585ec218&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ccjoe\\Documents\\CC2\\CareControlJobs\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585ec218"]])

export default __exports__